import React from 'react'
import { useLocale } from '../contexts/LocaleContext'

function FAQ() {
  const { t } = useLocale()

  return (
    <section id="faq" className="section">
      <div className="container">
        <h2>{t.faq.title}</h2>
        <div className="faq">
          <div className="faq-item">
            <h3>{t.faq.iosAndroid.question}</h3>
            <p>{t.faq.iosAndroid.answer}</p>
          </div>
          <div className="faq-item">
            <h3>{t.faq.import.question}</h3>
            <p>{t.faq.import.answer}</p>
          </div>
          <div className="faq-item">
            <h3>{t.faq.account.question}</h3>
            <p>{t.faq.account.answer}</p>
          </div>
          <div className="faq-item">
            <h3>{t.faq.cardio.question}</h3>
            <p>{t.faq.cardio.answer}</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FAQ
